import { Component, h, Prop, State, Event, Element, EventEmitter, Listen } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'app-hero-slide',
    styleUrl: 'app-hero-slide.scss',
    shadow: false
})
export class AppHeroSlide {

    @Element() root: HTMLElement;

    @Prop() desktopImg: string;
    @Prop() mobileImg: string;
    @Prop() pauseIcon: string = 'pause';

    @State() bgImage: string;

    @Event({
        eventName: 'sliderPaused',
        composed: true,
        cancelable: true,
        bubbles: true,
    }) sliderPaused: EventEmitter<any>;

    pauseBtnHandler(event) {
        const pauseBtn = event.target.closest('.hero-slider-pause');
        pauseBtn.classList.toggle('paused');
        
        if (pauseBtn.classList.contains('paused')) {
            this.pauseIcon = "play";
            this.sliderPaused.emit(true);
        } else {
            this.pauseIcon = "pause";
            this.sliderPaused.emit(false);
        }
    }

    @Listen('sliderPaused', {target: 'document'})
    sliderPausedHandler(event: CustomEvent<boolean>) {
        const pauseBtn = this.root.querySelector('.hero-slider-pause');
        if (event.detail === true && pauseBtn) {
            this.pauseIcon = "play";
            pauseBtn.classList.add('paused');
            
        } else if(pauseBtn) {
            this.pauseIcon = "pause";
            pauseBtn.classList.remove('paused');
        }
    }

    componentWillLoad() {
        this.setImg();

        window.addEventListener('resize', () => {
            this.setImg();
        });
    }

    setImg() {
        if (!Boolean(this.mobileImg) || this.mobileImg == '') {
            this.bgImage = this.desktopImg;
        } else if (window.innerWidth >= 992) {
            this.bgImage = this.desktopImg;
        } else {
            this.bgImage = this.mobileImg;
        }
    }

    render() {
        return (
            <div class="app-hero-slide">
                <div class="hero-inner">
                    <img class="hero-img" src={this.bgImage} alt="" role="presentation" />
                    <div class="hero-content">
                        <div class="hero-container">
                            <div class="hero-content-block">
                                <slot/>
                            </div>
                        </div>
                    </div>
                    <button class="hero-slider-pause" tabindex="-1" aria-label={this.pauseIcon} onClick={(event) => this.pauseBtnHandler(event)}>
                        <app-icon icon={this.pauseIcon}></app-icon>
                    </button>
                </div>
            </div>
        );
    }
}